import { useSyncExternalStore, useCallback } from 'react';
import { createPersistentStore } from './storeUtils';

export interface MobileShellState {
  launcherOpen: boolean;
  searchOpen: boolean;
}

const initialState: MobileShellState = {
  launcherOpen: false,
  searchOpen: false,
};

const store = createPersistentStore<MobileShellState>(initialState);

export function getMobileShellSnapshot(): MobileShellState {
  return store.getSnapshot();
}

export function subscribeMobileShell(listener: () => void): () => void {
  return store.subscribe(listener);
}

export function setLauncherOpen(open: boolean): void {
  store.set((prev) => (prev.launcherOpen === open ? prev : { ...prev, launcherOpen: open }));
}

export function setSearchOpen(open: boolean): void {
  store.set((prev) => (prev.searchOpen === open ? prev : { ...prev, searchOpen: open }));
}

export function useMobileShell() {
  const state = useSyncExternalStore(
    subscribeMobileShell,
    getMobileShellSnapshot,
    getMobileShellSnapshot
  );

  const openLauncher = useCallback(() => setLauncherOpen(true), []);
  const closeLauncher = useCallback(() => setLauncherOpen(false), []);
  const openSearch = useCallback(() => setSearchOpen(true), []);
  const closeSearch = useCallback(() => setSearchOpen(false), []);

  return {
    ...state,
    openLauncher,
    closeLauncher,
    openSearch,
    closeSearch,
  };
}
